import { IconButton, useTheme } from "@mui/material";
import { FlexContainer } from "../../components/FlexContainer";
import { ReactNode } from "react";
import { PlayArrow } from "@mui/icons-material";

export const TOOLBAR_HEIGHT = 64;

export function SecondaryToolbar({
  children,
  switcher,
  secMode
}: {
  children: ReactNode,
  switcher: (increment: number) => void,
  secMode: number
}) {
  const theme = useTheme();
  if (secMode === 0) {
    return (
      <IconButton onClick={() => switcher(1)} size='large'>
        <PlayArrow style={{ transform: 'rotate(270deg)' }} fontSize="large" />
      </IconButton>
    );
  }
  return (
    <FlexContainer sx={{
      height: TOOLBAR_HEIGHT,
      background: theme.palette.background.paper
    }}>
      <div>
        {children}
      </div>
      <div>
        <IconButton onClick={() => switcher(-1)} size='large'>
          <PlayArrow style={{ transform: 'rotate(90deg)' }} fontSize="large" />
        </IconButton>
        <IconButton onClick={() => switcher(1)} size='large'>
          <PlayArrow style={{ transform: 'rotate(270deg)' }} fontSize="large" />
        </IconButton>
      </div>
    </FlexContainer>
  );
}